
import { Patients } from "./patients";
import { Users } from "./users";
import { PatientAttente } from "./patient-attente";

export class InformationPatient {
  id: number;
  patient: Patients;
  patientAttente: PatientAttente;
  titre : string;
  description: string;
  nomFichier: string;
  create: any;
  user: Users;
  nombreUpdate: number;
  type: string
}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/models/information-patient.ts